<!--
 * @des: 获取小程序URL Scheme
 * @Author: zhc
 * @Date: 2022-06-257 14:55:54
-->
<template>
  <div class="pages">
  </div>
</template>

<script>
import { getScheme } from '@/api'
export default {
  name: 'SchemeLink',
  data() {
    return {
      COM_HTTP: getScheme,
    }
  },
  created() {},
  mounted() {
    const { url = '', path = '' } = this.$route.query
    if (this.$equipment() === null) {
      // PC端执行
      url ? window.location.href = url : this.getJTWeb()
    } else {
      // 移动端执行
      if (path) {
        const schemeLink = this.getCookie(url)
        // 如果cookie存在页面重定向到缓存的地址, 否则触发新的请求
        schemeLink ? window.location.href = schemeLink : this.getScheme(url, path)
        return
      }
      if (url) {
        // 如果路由地址有参数，则正常执行
        const schemeLink = this.getCookie(url)
        // 如果cookie存在页面重定向到缓存的地址, 否则触发新的请求
        schemeLink ? window.location.href = schemeLink : this.getScheme(url)
      } else {
        // 如果路由地址无参数，则跳转极兔官网
        this.getJTWeb()
      }
    }
  },
  methods: {
    // 获取cookie
    getCookie(key = 'schemeLink') {
      return this.$cookie.get(key)
    },
    // 请求小程序链接
    async getScheme(url, path = '') {
      const { code, msg, data } = await this.COM_HTTP.getSchemeUrl(url, path)
      if (code === 1) {
        // cookie缓存schemeLink， 期限29天
        this.$cookie.set(url, data, { expires: 29 })
        window.location.href = data // 页面重定向新的地址
      } else {
        alert(msg)
      }
    },
    // 访问极兔官网
    getJTWeb() {
      window.location.href = 'https://www.jtexpress.cn'
    },
  },
}
</script>

<style scoped lang="scss">
</style>
